








import { Vue, Component, Prop } from 'vue-property-decorator';
import { initialHelper } from '@/common/helpers';

@Component
export default class InitialsField extends Vue {
  @Prop() initials: string;
  @Prop() verifiedInitials: string;
  @Prop() fullName: string;
  @Prop() completed: boolean;
  @Prop() disabled: boolean;

  get text(): string {
    if (this.verifiedInitials) {
      return this.verifiedInitials;
    }
    if (this.completed) {
      return this.initials;
    }
    if (this.disabled) {
      return initialHelper(this.fullName);
    }
    return this.$t('initials-abbreviation').toString();
  }

  get isRequired(): boolean {
    return !this.disabled && !this.completed;
  }

  handleClick() {
    this.$emit('click');
  }
}
